import { roleApi } from "api/role.api";
import { action, makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";
import { adminRoutes, AppRoute } from "router";
import { settings } from "settings";
import { Permission } from "types/role";

class PermissionStore {
  permissions: Permission[] = [];
  accessRoutes: AppRoute[] = [];

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "PermissionStore",
      properties: ["permissions"],
      storage: localStorage,
    });
  }

  fetchPermissions = async (roleId: number) => {
    const res = await roleApi.findOne(roleId);
    this.permissions = res.data.permissions;
  };

  setAccessRoutes = () => {
    if (settings.checkPermission && this.permissions.length) {
      for (const route of this.accessRoutes) {
        if (!route.children) {
          const find = permissionStore.permissions.find(
            (e) => e.path == route.path
          );
          route.isAccess = !!find;
        } else {
          for (const childRoute of route.children) {
            const find = permissionStore.permissions.find(
              (e) => e.path == route.path + "/" + childRoute.path
            );

            childRoute.isAccess = !!find;
          }
          route.isAccess = route.children.some((e) => e.isAccess);
        }
      }
    }
  };
}

const permissionStore = new PermissionStore();

export { permissionStore };
